import {useStateCleaner} from '@local/hooks/useStateCleaner';

export const StateCleaner = () => {
  useStateCleaner();
  return null;
};
